export const getHepstarRefundLink = (booking_reference: string) => {
  /*
  For reference purposes. Github Issue Link: https://github.com/busbud/public-website/issues/14173#Notes
  Staging ID: 234
  Staging domain: https://test.form.refundable.me
  */

  const member_id = "200"; // Production ID
  return `https://form.refundable.me/forms/refund?memberId=${member_id}&bookingReference=${booking_reference}`;
};
